<template>
  <div class="bottom">
    <div class="box_21 flex-col">
      <div class="section_11 flex-row justify-between">
        <div class="box_22 flex-col">
          <span class="text_35">产品服务</span>
          <div class="block_1_bottom flex-col"></div>
          <span class="text_36">极光-罗盘车辆大数据服务</span>
<!--          <span class="text_37">极光-星海DPI大数据服务</span>-->
          <span class="text_38">极光-产业链图谱系统</span>
          <span class="text_39">极光-ESG绿色金融创新系统</span>
          <span class="text_40">极光-科技创新综合评价系统</span>
          <span class="text_41">极光-天启API大数据服务</span>
        </div>
        <div class="box_23 flex-col">
          <span class="text_42">法律法规</span>
          <div class="text-wrapper_13 flex-col">
            <span class="text_43" @click="handleClick('/privacy')">隐私政策</span>
          </div>
          <span class="text_44" @click="handleClick('/agreement')">信息源安全承诺书</span>
        </div>
        <div class="block_5 flex-col justify-between">
          <div class="group_1 flex-col">
            <span class="text_45">关注转化</span>
            <div class="box_25 flex-col"></div>
          </div>
          <span class="text_46">极光官方客服</span>
        </div>
        <div class="box_26 flex-col">
          <span class="text_47">联系我们</span>
          <div class="text-wrapper_14 flex-col">
            <span class="text_48">18115506413</span>
          </div>
        </div>
        <div class="block_6 flex-col justify-between">
          <div class="group_2 flex-col">
            <span class="text_49">关于极光</span>
            <div class="box_28 flex-col"></div>
          </div>
          <span class="text_50"
          >苏州极光数据有限公司是一家多场景、多链路的大数据企业，数据涵盖车辆场景、金融场景、政府服务、企业服务场景。公司在企业模型构建领域拥有DPI数据建模、科创评分模型、绿色金融评分模型、产业链图谱、创新营销模型、企业封控模型、企业竞品分析等多场景应用模型，通过公司自由的“大数据”共享平台，为金融机构、互联网、制造业等企业提供数据综合解决方案。</span
          >
        </div>
      </div>
      <div class="section_12 flex-row">
        <div class="text-group_7 flex-col justify-between">
            <span class="text_51"
            >地址：金枫创意商务中心 1 号楼 9 楼 905 - 906 室</span
            >
          <a class="text-wrapper_15" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="nofollow noopener noreferrer">
            <span class="text_52">Copyright</span>
            <span class="text_53">Ⓒ</span>
            <span class="text_54">2018&nbsp;苏州极光数据有限公司版权所有&nbsp;苏ICP备2023057581号-1</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "index",
  data() {
    return {
      codeUrl: "",

    };
  },
  mounted() {

  },
  methods: {
    handleClick(url) {
      window.open(this.$router.resolve(url).href, '_blank');
    },
  }
};
</script>

<style scoped lang="less">
.bottom {
  .box_21 {
    background-color: rgba(5, 15, 25, 1);
    width: 100vw;
  }

  .section_11 {
    width: 80.56vw;
    height: 14.66vw;
    margin: 2.77vw 0 0 9.72vw;
  }

  .box_22 {
    position: relative;
    width: 12.5vw;
    height: 14.66vw;
  }

  .text_35 {
    width: 4.94vw;
    height: 1.74vw;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 1.25vw;
    font-family: AlibabaPuHuiTi-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 1.74vw;
  }

  .block_1_bottom {
    width: 3.34vw;
    height: 11.25vw;
    margin-top: 1.67vw;
  }

  .text_36 {
    width: 9.45vw;
    height: 1.19vw;
    overflow-wrap: break-word;
    color: rgba(116, 142, 166, 1);
    font-size: 0.83vw;
    font-family: AlibabaPuHuiTi-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 1.19vw;
    margin-top: -9.23vw;
  }

  .text_37 {
    width: 9.17vw;
    height: 1.19vw;
    overflow-wrap: break-word;
    color: rgba(116, 142, 166, 1);
    font-size: 0.83vw;
    font-family: AlibabaPuHuiTi-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 1.19vw;
    margin-top: 0.84vw;
  }

  .text_38 {
    width: 7.78vw;
    height: 1.19vw;
    overflow-wrap: break-word;
    color: rgba(116, 142, 166, 1);
    font-size: 0.83vw;
    font-family: AlibabaPuHuiTi-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 1.19vw;
    margin-top: 0.84vw;
  }

  .text_39 {
    width: 10.14vw;
    height: 1.19vw;
    overflow-wrap: break-word;
    color: rgba(116, 142, 166, 1);
    font-size: 0.83vw;
    font-family: AlibabaPuHuiTi-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 1.19vw;
    margin-top: 0.84vw;
  }

  .text_40 {
    width: 10.21vw;
    height: 1.19vw;
    overflow-wrap: break-word;
    color: rgba(116, 142, 166, 1);
    font-size: 0.83vw;
    font-family: AlibabaPuHuiTi-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 1.19vw;
    margin-top: 0.84vw;
  }

  .text_41 {
    position: absolute;
    left: 0;
    top: 3.41vw;
    width: 9.17vw;
    height: 1.19vw;
    overflow-wrap: break-word;
    color: rgba(116, 142, 166, 1);
    font-size: 0.83vw;
    font-family: AlibabaPuHuiTi-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 1.19vw;
  }

  .box_23 {
    width: 12.5vw;
    height: 14.66vw;
    margin-left: 1.53vw;
  }

  .text_42 {
    width: 4.94vw;
    height: 1.74vw;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 1.25vw;
    font-family: AlibabaPuHuiTi-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 1.74vw;
  }

  .text-wrapper_13 {
    height: 11.25vw;
    margin-top: 1.67vw;
    width: 3.34vw;
  }

  .text_43 {
    width: 3.34vw;
    height: 1.19vw;
    overflow-wrap: break-word;
    color: rgba(116, 142, 166, 1);
    font-size: 0.83vw;
    font-family: AlibabaPuHuiTi-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 1.19vw;
    cursor: pointer;
  }

  .text_44 {
    width: 6.6vw;
    height: 1.19vw;
    overflow-wrap: break-word;
    color: rgba(116, 142, 166, 1);
    font-size: 0.83vw;
    font-family: AlibabaPuHuiTi-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 1.19vw;
    margin: -9.23vw 0 8.05vw 0;
    cursor: pointer;
  }

  .block_5 {
    width: 12.5vw;
    height: 12.71vw;
    margin-left: 1.6vw;
  }

  .group_1 {
    height: 8.62vw;
    width: 12.5vw;
    position: relative;
  }

  .text_45 {
    width: 4.94vw;
    height: 1.74vw;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 1.25vw;
    font-family: AlibabaPuHuiTi-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 1.74vw;
  }

  .box_25 {
    border-radius: 2px;
    background-image: url('../img/kf.png');
    background-size: 100% 100%;
    position: absolute;
    left: 0;
    top: 3.41vw;
    width: 7.5vw;
    height: 7.5vw;
  }

  .text_46 {
    width: 4.94vw;
    height: 1.19vw;
    overflow-wrap: break-word;
    color: rgba(116, 142, 166, 1);
    font-size: 0.83vw;
    font-family: AlibabaPuHuiTi-Regular;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 1.19vw;
    margin: 2.91vw 0 0 1.31vw;
  }

  .box_26 {
    height: 6.74vw;
    margin-left: 1.53vw;
    width: 12.5vw;
    position: relative;
  }

  .text_47 {
    width: 5vw;
    height: 1.25vw;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 1.25vw;
    font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 1.46vw;
  }

  .text-wrapper_14 {
    height: 3.89vw;
    width: 11.95vw;
    position: absolute;
    left: 0;
    top: 3.41vw;
  }

  .text_48 {
    width: 5.28vw;
    height: 1.19vw;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 0.83vw;
    font-family: AlibabaPuHuiTi-Regular;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 1.19vw;
  }

  .block_6 {
    width: 24.38vw;
    height: 10.49vw;
    margin-left: 1.53vw;
  }

  .group_2 {
    height: 6.74vw;
    width: 12.5vw;
    position: relative;
  }

  .text_49 {
    width: 4.94vw;
    height: 1.74vw;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 1.25vw;
    font-family: AlibabaPuHuiTi-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 1.74vw;
  }

  .box_28 {
    position: absolute;
    left: 0;
    top: 3.41vw;
    width: 11.95vw;
    height: 3.89vw;
  }

  .text_50 {
    width: 24.38vw;
    height: 7.09vw;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 0.83vw;
    font-family: AlibabaPuHuiTi-Regular;
    font-weight: normal;
    text-align: justify;
    line-height: 1.19vw;
    margin-top: -3.33vw;
  }

  .section_12 {
    width: 27.16vw;
    height: 3.2vw;
    margin: 7.63vw 0 1.66vw 36.45vw;
  }

  .text-group_7 {
    width: 27.16vw;
    height: 3.2vw;
  }

  .text_51 {
    width: 24.66vw;
    height: 1.19vw;
    overflow-wrap: break-word;
    color: rgba(116, 142, 166, 1);
    font-size: 0.83vw;
    font-family: AlibabaPuHuiTi-Regular;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 1.19vw;
    margin-left: 1.25vw;
  }

  .text-wrapper_15 {
    width: 27.16vw;
    height: 1.19vw;
    overflow-wrap: break-word;
    font-size: 0;
    font-family: AlibabaPuHuiTi-Regular;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 1.19vw;
    margin-top: 0.84vw;
  }

  .text_52 {
    width: 27.16vw;
    height: 1.19vw;
    overflow-wrap: break-word;
    color: rgba(116, 142, 166, 1);
    font-size: 0.83vw;
    font-family: AlibabaPuHuiTi-Regular;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 1.19vw;
  }

  .text_53 {
    width: 27.16vw;
    height: 1.19vw;
    overflow-wrap: break-word;
    color: rgba(116, 142, 166, 1);
    font-size: 0.83vw;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 1.19vw;
  }

  .text_54 {
    width: 27.16vw;
    height: 1.19vw;
    overflow-wrap: break-word;
    color: rgba(116, 142, 166, 1);
    font-size: 0.83vw;
    font-family: AlibabaPuHuiTi-Regular;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 1.19vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/v2/components/bottom.vue